import { profile } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useUpdateEmail = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => profile.updateEmail(data),
    onSuccess: () => {
      queryClient.invalidateQueries(['profile'])
    },
  })

	return mutation
}